import React from 'react';
import { Facebook } from 'lucide-react';

export const FACEBOOK_URL = 'https://www.facebook.com/share/1FpUxS5cL9/';

/**
 * Footer social links. Standard business-site treatment: a small circular
 * icon button that opens the JustDeliver Facebook page in a new tab.
 */
export const SocialLinks = ({ label = 'Follow us', className = '' }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="footer-social">
    {label && <span className="text-xs font-semibold text-gray-500">{label}</span>}
    <a
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="JustDeliver on Facebook"
      title="JustDeliver on Facebook"
      className="w-9 h-9 rounded-full border border-gray-200 bg-white text-[#1877F2] flex items-center justify-center
                 transition-all duration-200 hover:bg-[#1877F2] hover:text-white hover:border-[#1877F2]
                 hover:-translate-y-0.5 hover:shadow-md active:scale-95"
      data-testid="footer-facebook-link"
    >
      <Facebook className="w-[18px] h-[18px]" strokeWidth={2} />
    </a>
  </div>
);

export default SocialLinks;
